/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux';
import { createReducer, createAction } from '@reduxjs/toolkit';

export const filterListByQuery = createAction('@@apisList/FILTER_BY_QUERY');
export const clearFilters = createAction('@@apisList/CLEAR_FILTERS');

const initialFilter = { query: null };
const filter = createReducer(initialFilter, {
  [clearFilters]() {
    return initialFilter;
  },
  [filterListByQuery](state, { payload }) {
    state.query = payload;
  }
});

const apisList = combineReducers({
  filter
});

export const getFilter = (state) => state.apisList.filter;

export default apisList;
